import { CustomElementBase } from '../CustomElementBase'
import { observeBlock } from '../../sem-2.0/helpers/is-observers'

export class AccessibilityHiddenFocusGroupElement extends CustomElementBase {
  onInitialized() {
    observeBlock(this)
  }
}
